import React, { Fragment, useState, useEffect } from 'react';
import axios from 'axios';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowForward from '@mui/icons-material/ArrowForward';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Modal from '@mui/material/Modal';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '@mui/material';
import { fetchData, deleteData, activateData } from './apiService';
import { useAuth } from './AuthContext';
import { tokenIsExpired } from './authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import NotificationsIcon from '@mui/icons-material/Notifications';
import CancelIcon from '@mui/icons-material/Cancel';
import { EditSharp, Spa } from '@mui/icons-material';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';


function AmountRequest() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [selectedEngineer, setSelectedEngineer] = useState('');
    const [transferData, setTransferData] = useState({});
    const [selectedStaff, setSelectedStaff] = useState('');
    const [staffOptions, setStaffOptions] = useState([]);
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    const { isAuthenticated, companyId, permissions, token, userId, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // fetchData();
    }, [isAuthenticated, companyId, token, userId, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    // useEffect(() => {
    //     fetchStaff();
    //     fetchTableData();
    // }, []);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter(item =>
        Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [notificationList, setNotificationList] = useState([]);
    const StyledHeader = styled.h2`
    font-size: 24px;
    font-weight: bold;
    color: #333; /* Change the color as per your preference */
    text-transform: uppercase;
    border-bottom: 2px solid #ccc; /* Add a border for a more elegant look */
    padding-bottom: 5px; /* Adjust the padding as needed */
    margin-bottom: 20px; /* Add some bottom margin for spacing */
  `;

    useEffect(() => {
        fetchNotificationList();
    }, []);

    const fetchNotificationList = async () => {
        try {
            // const response = await axios.get(`https://localhost:7291/api/AmountRequestedApi/${companyId}`);
            const response = await axios.get(`https://pp-api.off-ease.com/api/AmountRequestedApi/${companyId}`);
            console.log('Response data:', response.data); // Log the response data
            if (Array.isArray(response.data.response_data) && response.data.response_data.length > 0) {
                setNotificationList(response.data.response_data);
            } else {
                console.error('Error: Response data is not an array or is empty');
            }
        } catch (error) {
            console.error('Error fetching notification list:', error);
        }
    };


    const [notificationDetails, setNotificationDetails] = useState(null); // State for holding notification details
    const [showNotificationModal, setShowNotificationModal] = useState(false); // State for managing modal visibility
    // Function to open notification modal
    const openNotificationModal = (notification) => {
        setNotificationDetails(notification);
        setShowNotificationModal(true);
    };

    // Function to close notification modal
    const closeNotificationModal = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const handleCloseInvoiceDialog = () => {
        setShowNotificationModal(false);
        setNotificationDetails(null);
    };

    const [showModal, setShowModal] = useState(false);

    // Function to toggle modal visibility
    const toggleModal = () => {
        setShowModal(!showModal);
    };

    const [qtyshowModal, setqtyShowModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [quantity, setQuantity] = useState('');


    const handleRequest = (itemId, spare, spareId, engineerId, staff, quantity, EStkId) => {
        setSelectedItem({ id: itemId, spare: spare, spareId: spareId, engineerId: engineerId, staff: staff, quantity: quantity, EStkId: EStkId });
        setqtyShowModal(true);
    };

    const handleReturn = (item) => {
        setSelectedItem(item);
        setqtyShowModal(true);
    };

    const handleCloseModal = () => {
        setqtyShowModal(false);
        setSelectedItem(null);
        setQuantity('');
    };




    const ApprovedClaims = async (item) => {
        try {

            const Claims = {
                ExpenseID: item.expenseID,
                ExpenseItemID: item.id,
                isApproved: true,
                modifiedBy: userId
            };

            const expenseId = item.expenseID;
            // Make the PUT request using axios
            //const response = await axios.put(`https://localhost:7291/api/ExpenseApi/${expenseId}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/ExpenseApi/${expenseId}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIsLoading(false);
            console.log('Claim Approve successed:', response.data);

            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Claim Approved error:', error);
        }
    };


    // Rejected Claims
    const RejectedClaims = async (item) => {
        try {

            const Claims = {
                ExpenseID: item.expenseID,
                ExpenseItemID: item.id,
                IsRejected: true,
                modifiedBy: userId
            };

            const expenseId = item.expenseID;
            // Make the PUT request using axios
            //const response = await axios.put(`https://localhost:7291/api/ExpenseApi/${expenseId}`, Claims, {
            const response = await axios.put(`https://pp-api.off-ease.com/api/ExpenseApi/${expenseId}`, Claims, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setIsLoading(false);

            console.log('Claim Approve successed:', response.data);


            setTimeout(() => {
                window.location.reload();
            }, 3000);
        } catch (error) {
            console.error('Claim Approved error:', error);
        }
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className="w-full mb-2 flex">
                <div style={{ position: 'relative' }} onClick={() => openNotificationModal(notificationList)}>
                    <Tooltip title="Amount Request">
                        <IconButton>
                            <CurrencyExchangeIcon style={{ color: 'goldenrod', fontWeight: 'bolder' }} />
                        </IconButton>
                    </Tooltip>
                    {notificationList.length > 0 && (
                        <div className='notification-count'>
                            {notificationList.length}
                        </div>
                    )}
                </div>
            </div>

            <Modal
                open={showNotificationModal}
                onClose={closeNotificationModal}
                className={showNotificationModal ? 'notification-modal' : ''}
            >
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '1300px', marginTop: '-270px' }}>
                        <div className="w-full mb-2 flex justify-end">
                            <Tooltip title="Close">
                                <button className="close-button" onClick={closeNotificationModal} style={{ marginLeft: '8px' }}><CancelIcon /></button>
                            </Tooltip>
                        </div>
                        <h3 style={{ fontFamily: 'Times New Roman', textAlign: 'center', color: 'brown' }}>Request Amount Details</h3>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead sx={{ backgroundColor: '#f3f3f3' }}>
                                    <TableRow>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Sl.No</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Date</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>ExpeneType</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Engineer</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Note.</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Amount</TableCell>
                                        <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '16px', padding: '7px' }}>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>

                                    {notificationList.map((item, index) => (
                                        <TableRow key={item.Id}>
                                            <TableCell sx={{ fontSize: '16px' }}>{index + 1}</TableCell>
                                            <TableCell sx={{ borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '14px', padding: '4px' }}>
                                                {item.createdDate && new Date(item.createdDate).toLocaleDateString('en-GB')}
                                            </TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '8px 4px' }}>{item.expenseType}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '8px 4px' }}>{item.engineerName}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '8px 4px', fontWeight: 'bolder' }}>{item.note}</TableCell>
                                            <TableCell sx={{ fontSize: '18px', padding: '8px 4px', fontWeight: 'bolder', color: 'darkorange' }}>{item.amount}</TableCell>
                                            <TableCell sx={{ fontSize: '14px', padding: '8px 4px' }}>
                                                <Fragment>
                                                    {item.isApproved && (
                                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                            <span style={{ color: 'green', marginLeft: '20px', fontWeight: 'bolder' }}>Approved</span>
                                                        </td>
                                                    )}
                                                    {item.isRejected && (
                                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                            <span style={{ color: 'red', marginLeft: '20px', fontWeight: 'bolder' }}>Rejected</span>
                                                        </td>
                                                    )}
                                                    {!item.isApproved && !item.isRejected && (
                                                        <td style={{ padding: '8px', marginTop: '-15px' }}>
                                                            <Tooltip title="Approve">
                                                                <IconButton
                                                                    style={{ padding: '8px', marginTop: '-10px', color: 'green', marginRight: '5px' }}
                                                                    onClick={() => ApprovedClaims(item)}
                                                                >
                                                                    <CheckCircleIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Reject">
                                                                <IconButton
                                                                    style={{ padding: '8px', marginTop: '-10px', color: 'red' }}
                                                                    onClick={() => RejectedClaims(item)}
                                                                >
                                                                    <CancelIcon />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </td>
                                                    )}
                                                </Fragment>
                                            </TableCell>


                                        </TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Modal>


        </div >
    );
}

export default AmountRequest;

